export class ChemiseCreateUpdate {
  fardeId: number;
  classementId: number;
  serviceId: number;
  serviceIds: number[];
  description: string;
  localisation: string;
  remarques: string;
  classementAffine: string;
  accesRestreint: boolean;
  archive: boolean;
}
